<script setup lang="ts">
    import TemplateSelector from '@/components/TemplateSelector.vue';
    import TemplateFields from '@/components/TemplateFields.vue';
    import { EAppStep } from '@/typescript/enums/EAppStep';
    import useConfigStore from '@/store/config.store';
    import { storeToRefs } from 'pinia';

    const { currentStep } = storeToRefs(useConfigStore());
</script>
<template>
    <div class="h-full bg-bg-secondary">
        <TemplateSelector v-if="currentStep === EAppStep.TEMPLATES" />
        <TemplateFields v-else-if="currentStep == EAppStep.EDITION" />
    </div>
</template>
